'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _buttonBar = require('./button-bar.cssm');

var _buttonBar2 = _interopRequireDefault(_buttonBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonBar = function (_Component) {
  _inherits(ButtonBar, _Component);

  function ButtonBar() {
    _classCallCheck(this, ButtonBar);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ButtonBar).apply(this, arguments));
  }

  _createClass(ButtonBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var className = _props.className;


      var classes = (0, _classnames2.default)(_buttonBar2.default.base, 'ls-button-bar', className);

      return _react2.default.createElement(
        'div',
        { className: classes },
        children
      );
    }
  }]);

  return ButtonBar;
}(_react.Component);

ButtonBar.propTypes = {
  children: _react.PropTypes.any,
  className: _react.PropTypes.string
};
exports.default = ButtonBar;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2J1dHRvbi1iYXIvYnV0dG9uLWJhci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFBOzs7O0FBS0E7Ozs7QUFDQTs7Ozs7Ozs7Ozs7O0lBRXFCLFM7Ozs7Ozs7Ozs7OzZCQU1WO0FBQUEsbUJBQ3lCLEtBQUssS0FEOUI7QUFBQSxVQUNDLFFBREQsVUFDQyxRQUREO0FBQUEsVUFDVyxTQURYLFVBQ1csU0FEWDs7O0FBR1AsVUFBTSxVQUFVLDBCQUNkLG9CQUFPLElBRE8sRUFFZCxlQUZjLEVBR2QsU0FIYyxDQUFoQjs7QUFNQSxhQUNFO0FBQUE7QUFBQSxVQUFLLFdBQVcsT0FBaEI7QUFBMEI7QUFBMUIsT0FERjtBQUdEOzs7Ozs7QUFsQmtCLFMsQ0FDWixTLEdBQVk7QUFDakIsWUFBVSxpQkFBVSxHQURIO0FBRWpCLGFBQVcsaUJBQVU7QUFGSixDO2tCQURBLFM7QUFtQnBCIiwiZmlsZSI6ImJ1dHRvbi1iYXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHtcbiAgQ29tcG9uZW50LFxuICBQcm9wVHlwZXMsXG59IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IGNsYXNzTmFtZXMgZnJvbSAnY2xhc3NuYW1lcyc7XG5pbXBvcnQgc3R5bGVzIGZyb20gJy4vYnV0dG9uLWJhci5jc3NtJztcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgQnV0dG9uQmFyIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgc3RhdGljIHByb3BUeXBlcyA9IHtcbiAgICBjaGlsZHJlbjogUHJvcFR5cGVzLmFueSxcbiAgICBjbGFzc05hbWU6IFByb3BUeXBlcy5zdHJpbmcsXG4gIH07XG5cbiAgcmVuZGVyKCkge1xuICAgIGNvbnN0IHsgY2hpbGRyZW4sIGNsYXNzTmFtZSB9ID0gdGhpcy5wcm9wcztcblxuICAgIGNvbnN0IGNsYXNzZXMgPSBjbGFzc05hbWVzKFxuICAgICAgc3R5bGVzLmJhc2UsXG4gICAgICAnbHMtYnV0dG9uLWJhcicsXG4gICAgICBjbGFzc05hbWVcbiAgICApO1xuXG4gICAgcmV0dXJuIChcbiAgICAgIDxkaXYgY2xhc3NOYW1lPXtjbGFzc2VzfT57Y2hpbGRyZW59PC9kaXY+XG4gICAgKTtcbiAgfVxufTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/@chartbeat/light-side/lib/components/button-bar/button-bar.js
// module id = 142
// module chunks = 0